<template>
  <Print v-if="isPrint" :form="form" :board="board" />
  <div v-else>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :multiple-disaster="true" :options="[{ type: 'file', label: '필수 첨부서류', value: 'file', labelStyle: 'color:#EA5455' }]" />

    <!-- 작업구분 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업구분</h5>

      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <fragment v-for="(checkbox, checkIndex) in form.inspectionList" :key="checkbox.id">
          <div class="col-span-3 flex items-center" v-if="checkIndex != 0">
            <PrintCheckbox v-if="isPrint || board.readonly" :label="checkbox.title" :value="checkbox.check" color />
            <label v-else class="flex">
              <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
              {{ checkbox.title }}
            </label>
          </div>
        </fragment>
      </div>
    </div>

    <!--작업허가서 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업허가서 정보</h5>
      <div class="writeGridContainer mt-4">
        <div>
          <div>작업일자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <date-selector class="w-full" v-model="form.inputB_1" :readonly="board.readonly" />
        </div>
        <div>
          <div>협력업체명</div>
          <span v-if="isPrint" class="print-input"> {{ form.companyName }} </span>
          <CompanySelector v-else :readonly="board.readonly" v-model="form.inputB_2" placeholder="선택" @select="targetCompany"></CompanySelector>
        </div>
        <div>
          <div>허가번호</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_3" />
        </div>

        <div>
          <div>관리감독자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_4" />
        </div>
        <div>
          <div>작업내용</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_5" />
        </div>
        <div>
          <div>작업장소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_6" />
        </div>

        <div>
          <div>주간작업</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_7 }} ~ {{ form.inputB_8 }}</p>
          <div v-else class="time">
            <time-selector v-model="form.inputB_7" :readonly="board.readonly" />
            <p class="px-2">~</p>
            <time-selector v-model="form.inputB_8" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div>야간연장<br />(18:00 이후)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_9 }} ~ {{ form.inputB_10 }}</p>
          <div v-else class="time">
            <time-selector v-model="form.inputB_9" :readonly="board.readonly" />
            <p class="px-2">~</p>
            <time-selector v-model="form.inputB_10" :readonly="board.readonly" />
          </div>
        </div>
        <div></div>

        <div>
          <div>주간인원</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_11 }}</p>
          <comma-input :readonly="board.readonly" v-else v-model="form.inputB_11" />
        </div>
        <div>
          <div>야간인원</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_12 }}</p>
          <comma-input :readonly="board.readonly" v-else v-model="form.inputB_12" />
        </div>
      </div>
    </div>

    <!-- 목록표 -->
    <div
      v-for="(inspection, indexRows) in form.inspectionList"
      :key="indexRows"
    >

      <div
        v-if="inspection.check && inspection.title === '밀폐공간작업'"
        class="mt-28px"
      >
        <h5 class="mb-4"><i class="dot"></i> {{ inspection.title }}</h5>
        <table>
          <thead>
          <tr>
            <th>
              <div class="text-left mx-4">
                작업허가서는 당일 작업에 한해 유효하며, 산소 및 유해가스의 농도에 따라서 작업시간에 제한이 있을 수도 있습니다.
                이 허가서는 지정된 장소와 시간에 대해 1회만 유효합니다.
                위 공간에서의 작업을 다음의 조건하에서만 허가함.
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td style="padding: 14px;">
              <div class="flex">
                <div style="width: 300px; align-self: center; font-weight: 500;">화기작업허가 필요유무</div>
                <div class="pt-1">
                  <vs-radio class="mx-2" v-model="form.inputC_1" :disabled="board.readonly" vs-name="need" vs-value="필요">필요</vs-radio>
                  <vs-radio class="mx-2" v-model="form.inputC_1" :disabled="board.readonly" vs-name="need" vs-value="불필요">불필요</vs-radio>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td style="padding: 14px;">
              <div class="flex">
                <div style="width: 300px; align-self: center; font-weight: 500;">내연기관(양수기) 또는 갈탄 등의 사용여부</div>
                <div class="pt-1">
                  <vs-radio class="mx-2" v-model="form.inputC_2" :disabled="board.readonly" vs-name="use" vs-value="사용">사용</vs-radio>
                  <vs-radio class="mx-2" v-model="form.inputC_2" :disabled="board.readonly" vs-name="use" vs-value="미사용">미사용(양수기등 작업중 가능성도 검증)</vs-radio>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

      </div>

      <TableInspectMerge
        v-if="inspection.check"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :title="inspection.title !== '밀폐공간작업' ? inspection.title : ''"
        tableHeaderTitle="작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)"
        :tableHeaderCheck="[{ text: '양호' }, { text: '불량' }, { text: 'N/A' }]"
        :isNote="inspection.title === '밀폐공간작업'"
        v-model="inspection.data"
        :class="inspection.title !== '밀폐공간작업'? 'mt-28px' : ''"
      />

      <table-custom
        v-if="inspection.check && inspection.title === '밀폐공간작업'"
        :controls="true"
        :multiple="true"
        :board="board"
        :is-print="isPrint"
        title="산소 및 유해가스 농도 측정결과"
        :tableData="[
        { id: 'name', title: '측정물질명', type: 'text', placeholder: '' },
        { id: 'density', title: '측정농도', type: 'text', placeholder: '' },
        { id: 'time', title: '측정시간', type: 'text', placeholder: '' },
        { id: 'watcher', title: '측정자', type: 'text', placeholder: '' },
        { id: 'confirm', title: '김시인 확인', type: 'text', placeholder: '' },
      ]"
        :mobile="['name', 'density', 'time', 'watcher', 'confirm']"
        v-model="form.inputC_3"
        class="mt-4"
      />
    </div>


    <!-- 기타특별사항 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 기타특별사항</h5>
      <div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputB_3 }}</p>
        <ml-textarea :readonly="board.readonly" v-else v-model="form.inputB_3" height="140px" />
      </div>
    </div>

    <!-- 확인자 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 결재란</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!-- 작업허가(추가연장) -->
    <table-custom
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      title="작업허가(추가연장)"
      :tableData="[
        { id: 'input1', title: '작업일', type: 'date', placeholder: '' },
        { id: 'input2', title: '작업시간', type: 'timeArr', placeholder: '' },
        { id: 'input3', title: '작성자', type: 'text', placeholder: '' },
        { id: 'input4', title: '검토자', type: 'text', placeholder: '' },
        { id: 'input5', title: '승인자', type: 'text', placeholder: '' },
      ]"
      :mobile="['target', 'name']"
      v-model="form.extension"
      class="mt-4"
    />

    <div class="flex flex-row justify-between items-center" style="background: #f9f9f9; border: 1px solid #cdcdcd">
      <p class="p-4">작업허가 요청 /연장 신청 시 상기 안전조치 사항을 이행하였음을 서명합니다.</p>
      <div class="flex flex-row items-center gap-4 p-4" style="border-left: 1px solid #cdcdcd">
        <sign-field v-model="form.sign3.sign" :readonly="board.readonly" class="bg-white" />
        <div>(인)</div>
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      :custom-title="true"
      placeholder="신축현장 점검"
      section-title="사진대지"
    >
      <template #customTitle>
        <div class="flex">
          <h5><i class="dot"></i> 작업계획도</h5>
          <div class="mx-2">※포함사항 : 작업위치, 운행경로, 작업반경, 출입 통제범위, 지장물(전선) 위치 등</div>
        </div>
      </template>
    </PhotoUploadGridModule>

    <!-- 파일첨부 -->
    <file-upload-module title="작업 계획도 및 관련 도면 첨부" id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import TableCustom from "@/components/TableCustom";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import Print from "./Print.vue";
import SignField from "@/components/SignField.vue";
import { helpers, required } from "vuelidate/lib/validators";
import inspectData from "./inspectData";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";

export default {
  components: {
    PhotoUploadGridModule,
    NameWithSignatureRow,
    Print,
    TimeSelector,
    TableInspectMerge,
    FieldSelectModule,
    FileUploadModule,
    CompanySelector,
    DateSelector,
    SignField,
    PrintCheckbox,
    TableCustom,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        file: { required },
      },
    },
  },
  computed: {
    inspectionList() {
      return [...inspectData];
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inspectionList: [],
        typeTitleList: [],

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",
        inputB_9: "",
        inputB_10: "",
        inputB_11: "",
        inputB_12: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: [
          { "id": 1, "name": "", "density": "", "time": "", "watcher": "", "confirm": "" },
          { "id": 2, "name": "", "density": "", "time": "", "watcher": "", "confirm": "" },
          { "id": 3, "name": "", "density": "", "time": "", "watcher": "", "confirm": "" },
        ],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },

        extension: [],

        photoList: [],
        fileList: [],
        companyName: "",
      },
      signlist: ["1. 신청자(협력사 소장)", "2. 검토자 (네트웍스 관리감독자)", "3. 검토자 (네트웍스 안전관리자)", "4. 승인자 (네트웍스 현장대리인)"],
    };
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectionList || this.form.inspectionList.length === 0) {
          this.form.inspectionList = this.inspectionList;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }

    if (!this.form || !this.form.inspectionList || this.form.inspectionList.length === 0) {
      this.form.inspectionList = this.inspectionList;
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.file.required) {
          return "필수 첨부서류를 첨부해주세요.";
        }
      }
    },
    checkForm() {
      this.form.typeTitleList = [];
      this.form.inspectionList.forEach((item) => {
        if (item.check) {
          this.form.typeTitleList.push(item.title);
        }
      });
    },
    updateListCheck(indexList, indexTableRows, indexRows, text) {
      this.form.inspectionList[indexList].list[indexTableRows].list[indexRows].is_checked = text;
    },
    targetCompany(value) {
      this.form.companyName = value.com_name;
    },
  },
};
</script>
<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  thead {
    th {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      color: #3c3c3c;
      background: #f9f9f9;
      padding: 16px 0;
    }
  }

  tbody {
    .title-tr td {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;

      background: #f9f9f9;
      padding: 14px;
    }
    .sub-title {
      text-align: center;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;

      background: #f9f9f9;
      padding: 14px 0;
    }

    .content {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      padding: 14px;
      & > div {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: 8px;
      }
    }
  }
}
table tr:last-child td {
  border-bottom: none;
}
</style>
